import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { STORAGE_URL } from "constants";
import { useLanguage } from "hooks";
import moment from "moment";

export default function MagazineInfo({ book, setStep, link, showSetLink }) {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";

  return (
    <section id="info" className="mb-3">
      <Container id="info_container" className="position-relative">
        <Row>
          <Col xl={4} lg={5} md={5} sm={12} xs={12}>
            <img
              src={`${STORAGE_URL}${link.cover_image}`}
              title={`figure`}
              alt={`figure`}
              className="w-100"
            />
          </Col>
          <Col xl={5} lg={7} md={7} sm={12} xs={12} className="p-3 p-lg-5">
            <Row>
              <Col xs={12}>
                <div className="mb-4 ">
                  <Col
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="text-end"
                  >
                    <button
                      onClick={() => setStep(1)}
                      className={`btn btn-outline-primary `}
                    >
                      {language.back}
                    </button>
                  </Col>
                  <Col xs={12}>
                    <h2 className="text-primary fw-medium h5">{book.name}</h2>
                  </Col>
                  <Col xs={12}>
                    <h4 className="text-black fw-normal">{book.sub_title}</h4>
                  </Col>

                  <Col xs={12}>
                    <ul className=" list-unstyled mt-4">
                      {[
                        {
                          label: language.editionNo,
                          value:
                            link.edition_no +
                            " " +
                            link.edition_breast_frequency,
                        },
                        {
                          label: language.date,
                          value: moment(link.publishing_date).format("YYYY"),
                        },
                        {
                          label: language.tags,
                          value: (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: link.tags,
                              }}
                            ></span>
                          ),
                        },
                      ].map(
                        (item, index) =>
                          item?.value && (
                            <li key={index}>
                              <h6 className="fw-medium text-blue w-100">
                                {item.label}: {item.value}
                              </h6>
                            </li>
                          )
                      )}
                    </ul>
                  </Col>

                  <Col xs={12}></Col>
                </div>
              </Col>
            </Row>
          </Col>
          <Col xl={3} lg={12} md={12} sm={12} xs={12}>
            {link.id && (
              <Row className="bg-white rounded-3 p-4 mt-4 mt-xl-5 mb-4 g-4">
                <Col xl={12} lg={6} md={6} sm={12} xs={12} className="">
                  <Row className="h-100 gy-4">
                    <Col
                      key={link.id}
                      xl={12}
                      lg={8}
                      md={8}
                      sm={12}
                      xs={12}
                      className="mx-auto"
                    >
                      <button
                        onClick={(e) =>
                          showSetLink({
                            ...link,
                          })
                        }
                        target="_blank"
                        rel="noreferrer"
                        className={`btn btn-primary btn-outline-primary-hover w-100`}
                      >
                        {link.type.name}
                      </button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
}
